<div class="page-wrapper">
    <div class="page-content" [ngClass]="{'scrollable': scrollable, 'keyboard-focused': appState.device.isKeyboardFocused()}">
        <ng-content></ng-content>
    </div>
</div>
